





































































































































































































/* eslint-disable @typescript-eslint/no-var-requires */
import { Vue, Component, Prop } from "vue-property-decorator";
import bisDatePicker from "@/components/bisDatePicker.vue";
import dayjs from "dayjs";
const customParseFormat = require("dayjs/plugin/customParseFormat");
dayjs.extend(customParseFormat);
import receipt from "@/components/receipt.vue";
import RequestHandler from "@/assets/ts/requestHandler.ts";
const requestHandler = new RequestHandler();

@Component({
  components: {
    bisDatePicker,
    receipt
  }
})
export default class ReportsExpanded extends Vue {
  @Prop({ required: true }) optionTypes!: Array<any>;
  voidInfo = {
    reason: "",
    showDialog: false,
    item: {} as any,
    voidTransCount: 0
  };
  voidLoading = false;
  stations: Array<{ text: string; value: string }> = [];
  dateModelFormat = "YYYY-MM-DD";
  searchParams: { [key: string]: any } = {
    optionType: undefined,
    startDate: dayjs().format(this.dateModelFormat),
    endDate: dayjs().format(this.dateModelFormat),
    stationID: undefined
  };
  loading = false;
  results: any = [];
  datePickerProps = {
    displayFormat: "MM/DD/YYYY", //Also used for hint
    TextField: {
      "hide-details": true
    },
    DatePicker: {
      "no-title": true
    },
    Menu: {
      ref: "menu",
      transition: "scale-transition",
      closeOnContentClick: false,
      "offset-y": true,
      "max-width": "290px",
      "min-width": "290px"
    }
  };

  baseHeaders = [
    { text: "Name", value: "Name" },
    { text: "Payment ID", value: "paymentID" },
    { text: "Date", value: "Date" },
    { text: "Bill Amt.", value: "BillAmt" },
    { text: "Fee", value: "ConAmt" },
    { text: "Client Fee", value: "ClientFee" },
    { text: "Total", value: "Total" }
  ];

  public quickSearchSelection = { startDate: "", endDate: "" };

  public quickSearchItems = [
    {
      text: "Today",
      value: {
        startDate: dayjs().format(this.dateModelFormat),
        endDate: dayjs().format(this.dateModelFormat)
      }
    },
    {
      text: "Yesterday",
      value: {
        startDate: dayjs()
          .subtract(1, "day")
          .format(this.dateModelFormat),
        endDate: dayjs()
          .subtract(1, "day")
          .format(this.dateModelFormat)
      }
    },
    {
      text: "This Week",
      value: {
        startDate: dayjs()
          .startOf("week")
          .format(this.dateModelFormat),
        endDate: dayjs()
          .endOf("week")
          .format(this.dateModelFormat)
      }
    },
    {
      text: "Last Week",
      value: {
        startDate: dayjs()
          .startOf("week")
          .subtract(1, "week")
          .format(this.dateModelFormat),
        endDate: dayjs()
          .endOf("week")
          .subtract(1, "week")
          .format(this.dateModelFormat)
      }
    },
    {
      text: "This Month",
      value: {
        startDate: dayjs()
          .startOf("month")
          .format(this.dateModelFormat),
        endDate: dayjs()
          .endOf("month")
          .format(this.dateModelFormat)
      }
    },
    {
      text: "Last Month",
      value: {
        startDate: dayjs()
          .startOf("month")
          .subtract(1, "month")
          .format(this.dateModelFormat),
        endDate: dayjs()
          .endOf("month")
          .subtract(1, "month")
          .format(this.dateModelFormat)
      }
    }
  ];

  async showVoidDialog(item: any) {
    const resp = await requestHandler.call({
      action: "getVoidTransCount",
      paymentID: item.paymentID
    });
    this.voidInfo.voidTransCount = resp.count;
    this.voidInfo.item = item;
    this.voidInfo.showDialog = true;
  }

  async voidTransaction() {
    if (this.voidInfo.reason == "") {
      return;
    }
    try {
      this.voidLoading = true;
      await requestHandler.call({
        action: "reversePayment",
        ttid: this.voidInfo.item.TTID,
        transactionID: this.voidInfo.item.TransID,
        paymentId: this.voidInfo.item.paymentID,
        reason: this.voidInfo.reason
      });
      this.$root.$emit("snackbar-message", {
        text: "The transaction was voided.",
        color: "green"
      });
      this.search();
    } catch (e) {
      console.error(e);
      this.$root.$emit("dialog-message", {
        text: `There was a problem saving the voided transaction. Please contact support to fix the records. <br/><br/> PaymentID: ${this.voidInfo.item.paymentID}<br/>TransactionID: ${this.voidInfo.item.TransID}`
      });
    } finally {
      this.voidLoading = false;
      Object.assign(this.voidInfo, {
        reason: "",
        showDialog: false,
        item: null
      });
    }
  }

  clearAll() {
    this.searchParams = {
      optionType: "",
      startDate: "",
      endDate: ""
    };
    this.results = [];
    this.quickSearchSelection = { startDate: "", endDate: "" };
  }
  showpdf = false;
  pdfdata: any = null;

  get reportHeaders() {
    const headers = Object.assign([], this.baseHeaders);
    switch (this.$store.getters.userInfo.Service) {
      case "Court":
        headers.splice(0, 0, { text: "Payment", value: "Option_Type" });
        break;
      case "TaxPayments":
        headers.splice(6, 0, {
          text: "P&I",
          value: "PenaltyAndInterest"
        });
        break;
    }
    headers.push(
      { text: "User", value: "User" },
      { text: "Actions", value: "actions" }
    );
    return headers;
  }

  public quickSearch() {
    Object.assign(this.searchParams, this.quickSearchSelection);
    this.search();
  }

  async search() {
    this.loading = true;
    try {
      this.results = await requestHandler.call(
        Object.assign({ action: "reports" }, this.searchParams)
      );
    } catch (e) {
      this.$root.$emit("snackbar-message", {
        text: "No results found.",
        color: "red"
      });
      console.error(e);
    } finally {
      this.loading = false;
    }
  }

  async created() {
    if (this.optionTypes.length == 1)
      this.searchParams.optionType = this.optionTypes[0];

    if (this.$store.getters.userInfo.Admin === "Y") {
      this.stations = await requestHandler.call({
        action: "getStations"
      });
    }
  }
}
